import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Loading = () => {
  return (
    <AiOutlineLoading3Quarters className="animate-spin size-8 w-full text-center" />
  );
};

export default Loading;
